module.exports = __webpack_public_path__ + "img/ios.c769d979.svg";